import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

function getUrlParameters() {
    var urlParams = {};
    (function () {
        var e,
            a = /\+/g,
            r = /([^&=]+)=?([^&]*)/g,
            d = function (s) {
                return decodeURIComponent(s.replace(a, " "));
            },
            q = window.location.search.substring(1);

        while (e = r.exec(q))
            urlParams[d(e[1])] = d(e[2]);
    })();
    return urlParams
};

function getLang() {
    if (navigator.languages != undefined)
        return navigator.languages[0];     
    return navigator.language;
  }

function getLocalisation(){
    if (navigator.languages != undefined){
        if(navigator.languages[0] === 'nl'){
            return 'nl-NL';
        }
        return navigator.languages[0]; 
    }
    return navigator.language;
}

async function fetchResponse(guid) {
    if (!guid) return null;

    const baseUrl = process.env.REACT_APP_BASE_URL;
    if (!baseUrl) {
        console.error("REACT_APP_BASE_URL is not defined");
        return null;
    }

    let jsonResponse = null;

    try {
        const response = await fetch(baseUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ Id: guid })
        });

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }

        const respJson = await response.json();
        const data = respJson.data ?? respJson.Data ?? respJson;

        if (!data || !data.chatToken || !data.chatToken.token) {
            throw new Error('Invalid API response: Missing chatToken');
        }

        return data;
    } catch (error) {
        console.error(error);
    }

    return jsonResponse;
}


async function createHybridPonyfillFactory(webchat) {
    const webSpeechPonyfillFactory = await webchat.createBrowserWebSpeechPonyfillFactory();
    return options => {
        const webSpeechPonyfill = webSpeechPonyfillFactory(options);
        return {
            SpeechGrammarList: webSpeechPonyfill.SpeechGrammarList,
            SpeechRecognition: webSpeechPonyfill.SpeechRecognition,
            speechSynthesis: null,
            SpeechSynthesisUtterance: null
        }
    };
}

async function checkIfIsImage(url) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute('src', url);
        img.addEventListener('error', (e) => reject(e));
        img.addEventListener('load', () => resolve());
    })
}

async function init(guid, params) {
    var response = await fetchResponse(guid);
    var preferredLanguage = getLang();
    params = {...params, preferredLanguage};
    if (!response) {
        ReactDOM.render(<span>BotID is invalid.</span>, document.getElementById('root'));
        return;
    }

    var {
        userId, chatName, locale, headerVisible, uploadButtonVisible, newMessagesNotificationEnabled,
        speechToTextEnabled, oldButtonsEnabled, supportedLocales, inConversationIconUrl, customStyling, sapCustomStyling,
        chatToken
    } = response;

    if (customStyling) {
        import("./customStyling.css");
    }

    if (sapCustomStyling) {
        import("./sapCustomStyling.css");
        locale = getLocalisation();
    }

    var adapter = speechToTextEnabled ? await createHybridPonyfillFactory(window.WebChat) : null;

    try {
        if (inConversationIconUrl) {
            await checkIfIsImage(inConversationIconUrl);
        }
    } catch (error) {
        console.error("Provided invalid custom image url:", inConversationIconUrl);
        inConversationIconUrl = null;
    }

    ReactDOM.render(
        <App userID={userId} token={chatToken.token} ponyFillAdapter={adapter}
            showUpload={false} locale={locale} supportedLocales={supportedLocales}
            showNewMessagesButton={newMessagesNotificationEnabled}
            disableOldButtons={oldButtonsEnabled}
            chatName={chatName}
            eventParams={params}
            inConversationIconUrl={inConversationIconUrl}
            customStyling={customStyling}
            sapCustomStyling={sapCustomStyling}
        />, document.getElementById('root'));

    if (headerVisible) {
        ReactDOM.render(<span className="bot-bar">{chatName}</span>, document.getElementById("bar"));
        document.getElementById("root").className = "with-bar";
    }
    document.querySelector('#root > *').focus();
}

//redirectToProperUrl();

let urlParams = getUrlParameters();
const { id, ...params } = urlParams;
let guid = id ? id : '';

init(guid, params);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

function redirectToProperUrl() {

    const currentOrigin = window.location.origin;
    const searchPattern = window.location.search;

    const urlToRedirect = 'https://dev.chatbots.abb.com';
    // const urlToRedirect = 'https://chatbots.abb.com';
    //const urlToRedirect = 'http://localhost:3000';

    //const redirectTo = `https://chatbots.abb.com/${searchPattern}`;
    const redirectTo = `https://dev.chatbots.abb.com/${searchPattern}`;
    //const redirectTo = `http://localhost:3000/${searchPattern}`;
    console.log("curent", currentOrigin, urlToRedirect)

    if (currentOrigin === urlToRedirect) {
        window.location.assign(redirectTo);
    }
}